// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__w0aJh","isLink":"Card_isLink__tF0zt","hasOnClick":"Card_hasOnClick__M9E6t"};